import { useQuery } from 'react-query'
import request from '../request'
import { useDealership } from '../../store/zustand/dealershipStore'
import { Vendor } from '../../lib/types/Vendor'

export const useGetThirdPartyVendors = () => {
  const dealership = useDealership()
  return useQuery<Array<Vendor>>(['3rd_party', 'vendors', dealership?.id], () =>
    request({
      url: `/agencies/${dealership?.organization_id}/dsp/third_party/${dealership?.id}/vendors`,
      method: 'GET',
    }).then((res: any) => res.data),
  )
}
